import React from 'react';
import PropTypes from 'prop-types';

import Label from '../../../../../../components/Label';
import Input from '../../../../../../components/Input';

const EmailInput = (props) => {
  const { value, onChange, errors } = props;
  return (
    <div>
      <Label
        name="email"
        title="Email of user to send the message to"
        errors={errors}
      />
      <Input id="email" type="email" onChange={onChange} value={value} />
    </div>
  );
};

export default EmailInput;

EmailInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

EmailInput.defaultPropd = {
  value: '',
  errors: {},
};
